import { TravelerGroup } from '@reward-platform/order-schemas/common'
import { useTranslations } from 'next-intl'

type FormatFunc = (count: number) => string
type ExecutionMap = Record<TravelerGroup['ageGroup'], FormatFunc>

export const useTravellersMessageFormatters = () => {
  const t = useTranslations('components.traveller_picker.labels')
  const tCommon = useTranslations('common.labels')

  const formatAdults: FormatFunc = (count) => t('adult_count', { count })

  const formatSeniors: FormatFunc = (count) => t('seniors_count', { count })

  const formatYouths: FormatFunc = (count) => t('youth_count', { count })

  const formatChildren: FormatFunc = (count) => t('child_count', { count })

  const formatInfants: FormatFunc = (count) => t('infants_count', { count })

  const formatTravelers: FormatFunc = (count) => tCommon('traveller_count', { count }).toLowerCase()

  const executionMap: ExecutionMap = {
    ADULT: formatAdults,
    SENIOR: formatSeniors,
    YOUTH: formatYouths,
    CHILD: formatChildren,
    INFANT: formatInfants,
    TRAVELER: formatTravelers,
  }

  const formatAgeGroupsAsList = (travelers: Pick<TravelerGroup, 'quantity' | 'ageGroup'>[]) =>
    travelers.map((group) => executionMap[group.ageGroup](group.quantity)).join(', ')

  return { formatAgeGroupsAsList }
}
